const tabs = (el) => {
    el.addEventListener('click', function(e){
        e.preventDefault();
        
        var tabId = el.dataset.tabId;
        var tabContent = document.querySelector('[data-content-id='+tabId+']');
        
        var wrapElements = document.querySelectorAll('.area-map__wrap--active');
        [].forEach.call(wrapElements, function(activeEl) {
            activeEl.classList.remove('area-map__wrap--active');
            activeEl.setAttribute('aria-hidden', 'true');
        });

        var tabElements = document.querySelectorAll('.area-map__tab--active');
        [].forEach.call(tabElements, function(activeEl) {
            activeEl.classList.remove('area-map__tab--active');
            activeEl.setAttribute('aria-expanded', 'false');
        });

        el.classList.add('area-map__tab--active');
        tabContent.classList.add('area-map__wrap--active');
        el.setAttribute('aria-expanded', 'true');
        tabContent.setAttribute('aria-hidden', 'false');
    });
}
export default tabs;